module.exports = __webpack_public_path__ + "static/media/inventorytabsimg.1a89a090.png";